const $ = window.jQuery;

const smoothScroll = {
    init: () => {

        $('.js-smooth-scroll').click(function(e){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $( $(this).attr('data-anchor') ).offset().top - 130
            }, 500);
            return false;
        });
        $('.cta-brochure-form').click(function(e){
            e.preventDefault();
            let brochure = $(this).attr('data-value');
            $('#product-form').find(":checkbox").filter(function() {
                return this.value === brochure;
            }).prop("checked", "true");

            $('input[value $=brochure]').attr('checked', this.checked);


            $('html, body').animate({
                scrollTop: $( $(this).attr('data-anchor') ).offset().top - 50
            }, 500);
            return false;
        });

        $('.cta-product-form').click(function(e){
            e.preventDefault();

            $('html, body').animate({
                scrollTop: $( $(this).attr('data-anchor') ).offset().top - 50
            }, 500);
            return false;
        });
    }
};
export default smoothScroll;
